import { Box, Stack } from "@mui/material";
import { navPaddingTop } from "../../constants";

const styles = {
  outer: {
    paddingTop: navPaddingTop,
    paddingBottom: "24px",
  },
  bg: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 0,
    backgroundImage:
      "linear-gradient(to right, rgba(250, 250, 150,0.5), #6dd5ed90)",
  },
  colorContainer: {
    px: "24px",
    paddingTop: "24px",
    width: "100%",
  },
};

export const JobOuterContainer = ({ sx, children }) => {
  return (
    <Stack
      direction="column"
      alignItems="center"
      sx={{
        ...styles.outer,
        ...sx,
      }}>
      {children}
    </Stack>
  );
};

export const JobBg = () => {
  return <Box sx={styles.bg} />;
};

export const JobInnerContainer = ({
  children,
  mobile = false,
  spacing = "24px",
  sx = null,
}) => {
  return (
    <Stack
      sx={{
        ...styles.colorContainer,
        ...sx,
      }}
      direction={mobile ? "column-reverse" : "row"}
      alignItems={mobile ? "center" : ""}
      justifyContent={mobile ? "" : "center"}
      spacing={spacing}>
      {children}
    </Stack>
  );
};

export const JobInnerColumn = ({ children, spacing = "16px" }) => {
  return (
    <Stack
      direction="column"
      alignItems="center"
      sx={{ width: "100%" }}
      spacing={spacing}>
      {children}
    </Stack>
  );
};
